import { skipToken } from '@apollo/client/react'
import {
  DeleteMangaDocument,
  GetMangaChapterDocument,
  GetMangaDocument,
  MarkMangaDocument,
} from './generated/graphql'
import { createMutationHelper, createQueryHook, modifyQueryHook } from './utils'

export const useGetManga = modifyQueryHook(createQueryHook(GetMangaDocument), {
  transform: (id: string) => ({ id }),
  reduce: res => res?.manga,
})

export const useGetMangaChapter = modifyQueryHook(
  createQueryHook(GetMangaChapterDocument),
  {
    transform: ({
      mangaId,
      chapterId,
      index,
    }: {
      mangaId?: string
      chapterId?: string
      index?: number
    } = {}) =>
      mangaId && (chapterId || index != null)
        ? { mangaId, chapterId, index }
        : skipToken,
    reduce: r => r?.manga?.chapter,
  },
)

export const [useDeleteManga, executeDeleteManga] =
  createMutationHelper(DeleteMangaDocument)

export const [useMarkManga, executeMarkManga] =
  createMutationHelper(MarkMangaDocument)
